'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {},
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      oList: []
    };
  },

  watch: {
    list: function list() {
      this.buildList();
    }
  },
  computed: {},
  created: function created() {
    this.buildList();
  },

  methods: {
    buildList: function buildList() {
      this.oList = this.list.map(function (item) {
        Vue.set(item, 'checked', item.checked || false);
        return item;
      });
    },
    checkChange: function checkChange(e) {
      e.checked = !e.checked;
      var checkedList = [];
      this.oList.forEach(function (item) {
        item.checked && checkedList.push(item.value);
      });
      this.$emit('optionClick', { checkedList: checkedList });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-date-cycle-picker/option-list-circle.vue
// module id = 325
// module chunks = 0 1